import {createAsyncThunk} from "@reduxjs/toolkit";
import {IGruntItem} from "./types";
import {api} from "../../../resources/api";
import {getTokenFromStorage} from "../../../utils";
import axios from "axios";
import {IArena} from "../../rent/types";

export const fetchAllGruntReserve = createAsyncThunk<IGruntItem[]>(
  "getGrunt/fetchAllGrunt",
  async () => {
    try {
      const url = `${api.BASE_URL}${api.cart.GET_ALL_GRUNT_RESERVE}`;
      const token = getTokenFromStorage();
      const response = await axios.get(url,{"headers": {
          "Authorization": `Bearer ${token}`
        }});

      return response.data;
    } catch (err) {
      console.log("error fetchGetToken >>>", err);
    }
  }
)

export const fetchGruntArenas = createAsyncThunk<IArena[], number>(
  "getGrunt/fetchGruntArenas",
  async (gruntId) => {
    try {
      const url = `${api.BASE_URL}${api.cart.GET_GRUNT_AREAS(gruntId)}`;
      const response = await axios.get(url);

      return response.data;
    } catch (err) {
      console.log("error fetchGetToken >>>", err);
    }
  }
)
